import { render, staticRenderFns } from "./ListarEmpresasRelacao.vue?vue&type=template&id=2f090a50"
import script from "./ListarEmpresasRelacao.vue?vue&type=script&lang=js"
export * from "./ListarEmpresasRelacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports